<template>
  <div class="feed" ref="feedContainer">
    <div v-if="publications.length === 0 && !loading" class="content-placeholder">
      <p>Your feed will appear here. Sorry we found nothing or internet connection's issue.</p>
      <button class="retry-btn" @click="fetchMore(true)">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="23 4 23 10 17 10"/>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
        </svg>
        Retry
      </button>
    </div>
    <LiveCard
      v-for="pub in publications"
      :key="pub._id"
      :publication="pub"
      @enter-live="openLive(pub)"
    />
    <ConferenceForm
      @showConference="openLive"
      ref="conferenceForm"
      admin-user-id="sarah.codes"
    />
    <button
      class="fab-golive"
      type="button"
      aria-label="Go live"
      @click="goLive"
    >
      <svg class="fab-golive__icon" viewBox="0 0 24 24" fill="none">
        <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19 11a7 7 0 0 1-14 0M12 18v3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Go live 
    </button>
    <LiveRoom ref="liveRoom" @showProfile="(user)=> profile.show(user)" />
    <Profile :visible="false" ref="profile" style="z-index: 2000;"/>
    <InfiniteScrollLoader
      :loading="loading"
      :has-more="hasMore"
      :root="feedContainer"
      @load-more="fetchMore"
    />
<!--     <Loader :loading="loading"/> -->
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import LiveCard from './Conference.vue'
import ConferenceForm from './ConferenceForm.vue';
/* import Loader from "@/views/components/loader/Loader.vue" */
import LiveRoom from './LiveRoom.vue';
import { ref, onMounted, inject } from 'vue'
import { useStore } from 'vuex'
import Profile from "@/views/profile/Profile.vue"
import InfiniteScrollLoader from '@/views/components/infiniteScrollLoader/InfiniteScrollLoader.vue';

const axios = inject('axios')
const store = useStore()

//--- infiniteScrollLoader --------
const feedContainer = ref(null)
//const isLoadingMore = ref(false)
const hasMore = ref(true)
const page = ref(0)


// Replace with your real feed, e.g. from an API call / store.
let publications = ref([])
const liveRoom = ref(null)
const conferenceForm = ref(null)
const profile = ref(null)
let loading = ref(false)

function openLive(conf) {
  // Wire this up to your existing live-room screen/router.
  // e.g. router.push({ name: 'live', params: { id: publication.userId } })
  liveRoom.value.show(conf)
}


function goLive () {
  if(!liveRoom.value.connected) conferenceForm.value.show()
  else liveRoom.value.unhide()
}
// ── Load publications ──────────────────────────────────────────────────────
async function fetchMore (isFirstConnection) {
  loading.value = true
  try {
    const res  = await axios.post('conference.php', { type: 'getFeed', page: page.value,isFirstConnection:isFirstConnection ? true : false })
    const pubs = res.data || []
    // console.log(pubs)
    if(pubs.length === 0 && page.value > 0) {// if the feeds is totaly consumed
      page.value = 0
      fetchMore(true)
      return
    }
    if(pubs.length === 0 ) return
    // console.log('resulllt',pubs)
    const newPubs = [...publications.value, ... pubs]


    // get users publishers metadatas________________________________________________________________
    const usersToGet = new Set()
    pubs.forEach(conf => {
      if(!store.state.users[conf.userId]) usersToGet.add(conf.userId)
      conf.actors.forEach(act => {
        if(!store.state.users[act.userId]) usersToGet.add(act.userId)
      })
    })

    if(usersToGet.size > 0) {
      const res2 = await axios.post('user.php',{type:"getUsersMetaData",users:[...usersToGet]})
      const users = res2.data || []
      users.forEach(us => {
        store.commit('setAnUser',us)
      })
    }

    publications.value = newPubs
    page.value ++ 

  } catch (e) {
    console.error(e?.response ?? e)
  } finally {
    loading.value = false
  }
}
async function search (str) {
  publications.value = []
  loading.value = true
  try {
    const res  = await axios.post('conference.php', { type: 'searchConferences', search: str })
    const pubs = res.data || []
/*     alert(JSON.stringify(pubs[1]))
    console.log('resulllt',pubs) */
    publications.value = pubs


    // get users publishers metadatas________________________________________________________________
    const usersToGet = new Set()
    publications.value.forEach(conf => {
      if(!store.state.users[conf.userId]) usersToGet.add(conf.userId)
      conf.actors.forEach(act => {
        if(!store.state.users[act.userId]) usersToGet.add(act.userId)
      })
    })

    if(usersToGet.size > 0) {
      const res2 = await axios.post('user.php',{type:"getUsersMetaData",users:[...usersToGet]})
      const users = res2.data || []
      users.forEach(us => {
        store.commit('setAnUser',us)
      })
    }

  } catch (e) {
    console.error(e?.response ?? e)
  } finally {
    loading.value = false
  }
}

function close () {
  if(store.state.audioPlayerVisibility === true) {
    store.commit('setAudioPlayerVisibility',false)
    return false
  }
  if(this.$refs.profile.Display ) {
    this.$refs.profile.hide()
    return false
  }
  if(conferenceForm.value.Display ) {
    conferenceForm.value.close()
    return false
  }
  if(liveRoom.value.Display) {
    liveRoom.value.hide()
    return false
  }
  return true
}
defineExpose({ openLive, search, close })

onMounted(async () => {
  fetchMore(true)
})

</script>

<style scoped>
.feed {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 16px;
  overflow: auto;
  margin: 0 auto;
  background: #0a0e1a;
  padding-bottom: 120px;
}

.content-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 20px;
}

.content-placeholder p {
  color: #94a3b8;
  font-size: 15px;
  max-width: 500px;
  line-height: 1.6;
  margin: 0;
}
.retry-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  padding: 10px 20px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  color: #00d4ff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.retry-btn svg {
  width: 16px;
  height: 16px;
}

.retry-btn:hover {
  background: rgba(0, 212, 255, 0.18);
  border-color: rgba(0, 212, 255, 0.5);
}

.fab-golive {
  position: fixed;
  right: 20px;
  bottom: 124px; /* adjust to clear your bottom nav bar height */
  display: flex;
  align-items: center;
  border: none;
  border-radius: 999px;
  padding: 14px 20px 14px 16px;
  background: linear-gradient(135deg, #ec4899, #8b5cf6);
  color: #fff;
  font-family: 'Inter', 'Sora', system-ui, -apple-system, sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.4);
  z-index: 50;
}

.fab-golive:hover {
  filter: brightness(1.08);
}

.fab-golive__icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}

@media (max-width: 340px) {
  .fab-golive {
    padding: 12px 16px 12px 14px;
    font-size: 13px;
  }
  .fab-golive__icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
</style>